import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import React, {Component, Fragment} from 'react';
import {actions as system} from '../reducers/system';
import {actions as label} from '../reducers/label';
import { Formik, Form, Field } from 'formik';
import Checkbox from '../components/form/Checkbox';
import _ from 'lodash';
import ScreenHeader from "../components/general/ScreenHeader";
import { HotKeys } from "react-hotkeys";
import button from "eslint-plugin-jsx-a11y/src/util/implicitRoles/button";

@connect(
	state => {
		return {
			selectedProject: state.project.selected,
			selectedLabelCollection: state.labelCollection.selected,
			selectedLabel: state.label.selected
		}
	},
	dispatch => {
		return {
			clearMessages: () => dispatch(system.clearMessages()),
			createLabel: (labelToCreate) => dispatch(label.create(labelToCreate)),
			updateLabel: (labelToUpdate) => dispatch(label.update(labelToUpdate))
		};
	})
export default class LabelForm extends Component
{
	constructor(props){
		super(props);

		this.state = {
			isUpdateMode: _.has(props.match.params, 'label'),
			isCreateAndNew: false,
			active: true
		};
	}

	submitForm = null;

	setSubmitFormFunc(submitFormFunc) {
		this.submitForm = submitFormFunc;
	}

	getRedirectPath() {
		return '/show/' + encodeURIComponent(this.props.selectedProject.name) + '/' + encodeURIComponent(this.props.selectedLabelCollection.identifier);
	}

	createLabel = (event) =>  {
		event.preventDefault();
		this.setState({isCreateAndNew: false}, this.submitForm);
	};

	createAndNew = (event) => {
		event.preventDefault();
		this.setState({isCreateAndNew: true}, this.submitForm);
	};

	render() {
		if(!this.props.selectedProject || !this.props.selectedLabelCollection || !this.state.active) {
			return null;
		}

		const initialState = this.props.selectedLabel || {
			name: '',
			defaultValue: '',
			internal: false,
			disallowEmpty: false,
			noValue: false,
			allowPlurals: false,
			allowMultiline: false,
		};


		const handlers = {
			SAVE_LABEL	: this.createLabel,
			SAVE_AND_NEW : this.createAndNew
		};

		// when the form is to update wait with rendering until the project is loaded
		return this.state.isUpdateMode && this.props.selectedLabel === null ? null : (
			<HotKeys handlers={handlers}>
				<Fragment>
					<div className="card">
						<ScreenHeader value={'Add label to collection "' + this.props.selectedLabelCollection.identifier + '"'} />

						<Formik
							initialValues={initialState}
							onSubmit={(label, actions) => {
								this.props.clearMessages();
								label.noValue = false;
								const promise = this.state.isUpdateMode ? this.props.updateLabel(label) : this.props.createLabel(label);
								promise.then(
									success => {
										if(success) {
											if (this.state.isCreateAndNew) {
												this.setState({active: false}, () => this.setState({active: true}));
											} else {
												this.props.history.push(this.getRedirectPath());
											}
										} else {
											actions.setSubmitting(false);
										}
									}
								);
							}}
							render={({ isSubmitting, submitForm, handleSubmit }) => {
								this.setSubmitFormFunc(submitForm);

								return (
									<Form>
										<div className="card-body">
											<div className="form-group has-label">
												<label>Key *</label>
												<Field type="text" className="form-control" name="name" />
											</div>
											<div className="form-group has-label">
												<label>Default Value</label>
												<Field type="text" className="form-control" name="defaultValue" />
											</div>
											<div className="form-check xpull-left">
												<label className="form-check-label">
													<Checkbox name="internal" />
													<span className="form-check-sign"/>
													internal (only admins can translate)
												</label>
											</div>
											<div className="form-check xpull-left">
												<label className="form-check-label">
													<Checkbox name="disallowEmpty" />
													<span className="form-check-sign"/>
													disallow empty
												</label>
											</div>
											<div className="form-check xpull-left">
												<label className="form-check-label">
													<Checkbox name="allowPlurals" />
													<span className="form-check-sign"/>
													allow plurals
												</label>
											</div>
											<div className="form-check xpull-left">
												<label className="form-check-label">
													<Checkbox name="allowMultiline" />
													<span className="form-check-sign"/>
													allow multiline
												</label>
											</div>
										</div>

										<div className="card-footer text-right">
											<Link to={this.getRedirectPath()} className="btn btn-secondary">Cancel</Link>
											<button title="ctrl+s" id="CreateLabel" type="submit" onClick={(e)=> this.setState({isCreateAndNew: false}, handleSubmit(e))} className="btn btn-primary" disabled={isSubmitting} ref={this.create}>
												{this.state.isUpdateMode ? 'Update label' : 'Create label'}
											</button>
											<button title="ctrl+shift+s" id="CreateAndNew" type="submit" onClick={(e)=> this.setState({isCreateAndNew: true}, handleSubmit(e))} className="btn btn-primary" disabled={isSubmitting}>
												{this.state.isUpdateMode ? 'Update And New' : 'Create And New'}
											</button>
										</div>
									</Form>
								);
							}}
						/>
					</div>
				</Fragment>
			</HotKeys>

		);
	};
}


// WEBPACK FOOTER //
// ./React/src/screens/LabelForm.js